export const nav_carbon = "Carbon";
export const nav_builds = "Builds";
export const nav_atelier = "Atelier";
export const nav_models = "Modelli";
export const nav_process = "Processo";
export const nav_contact = "Contatto";
export const nav_about = "Chi Siamo";
export const nav_cta = "Inizia il Tuo Build";

export const hero_tagline = "Realizzato in Carbonio. Costruito Senza Compromessi.";
export const hero_cta_primary = "Configura il Tuo";
export const hero_cta_secondary = "Esplora i Modelli";
export const hero_scroll = "Scorri per Scoprire";
export const hero_video_toggle = "Video";
export const hero_slides_toggle = "Diapositive";
export const hero_mute = "Muto";
export const hero_unmute = "Attiva Audio";

export const manifest_title = "Il Manifesto Veragua";
export const manifest_text = "Progettiamo oltre le convenzioni. Ogni componente è scrutato, ogni superficie raffinata. La fibra di carbonio non è una scelta di materiale—è la nostra fondazione. Le prestazioni non sono una caratteristica—sono la nostra ossessione. Non seguiamo le tendenze. Stabiliamo gli standard.";
export const manifest_line1 = "Questo non è styling.";
export const manifest_line2 = "Questa è ricostruzione.";
export const manifest_line3 = "Scansionato in 3D. Progettato. Rifinito a mano.";

export const carbon_title = "Divisione Carbon";
export const carbon_subtitle = "Eccellenza Ingegneristica";
export const carbon_desc = "La nostra Divisione Carbon rappresenta l'apice dell'ingegneria leggera. Ogni componente è meticolosamente realizzato in fibra di carbonio di grado aerospaziale, riducendo il peso massimizzando l'integrità strutturale e le prestazioni.";
export const carbon_cta = "Esplora la Tecnologia Carbon";
export const carbon_division_label = "DIVISIONE 01";
export const carbon_division_title1 = "CARBON";
export const carbon_division_title2 = "DIVISION";
export const carbon_division_desc = "Ogni componente viene sviluppato dal composito grezzo al pezzo finito internamente. Nessun outsourcing. Nessun compromesso.";
export const carbon_custom_config = "Configurazioni personalizzate disponibili per tutte le piattaforme.";
export const carbon_request_build = "RICHIEDI BUILD PERSONALIZZATO";
export const carbon_view_details = "VISUALIZZA DETTAGLI";
export const carbon_materials_label = "MATERIALI";
export const carbon_process_label = "PROCESSO";

export const builds_title = "Builds Signature";
export const builds_subtitle = "Capolavori in Movimento";
export const builds_view = "Visualizza Build";
export const builds_limited_series = "Serie Limitata";
export const builds_each_build = "Ogni build è una dichiarazione unica. Progettato alla perfezione. Limitato a dieci.";
export const builds_view_project = "VISUALIZZA PROGETTO";

export const engineering_title = "Dettagli Ingegneristici";
export const engineering_subtitle = "Precisione in Ogni Componente";
export const engineering_tab_chassis = "Telaio";
export const engineering_tab_aero = "Aerodinamica";
export const engineering_tab_power = "Gruppo Motopropulsore";
export const engineering_chassis_title = "Telaio Monoscocca in Carbonio";
export const engineering_chassis_desc = "Il nostro telaio monoscocca in fibra di carbonio proprietario offre una rigidità eccezionale mantenendo un peso minimo. Ogni strato è progettato con precisione per un rapporto resistenza-peso ottimale.";
export const engineering_aero_title = "Aerodinamica Attiva";
export const engineering_aero_desc = "I sistemi aerodinamici intelligenti si adattano in tempo reale, ottimizzando deportanza e resistenza per ogni condizione di guida. Testato in galleria del vento, provato in pista.";
export const engineering_power_title = "Gruppo Motopropulsore Ibrido";
export const engineering_power_desc = "La tecnologia ibrida avanzata combina potenza bruta ed efficienza. I motori elettrici forniscono coppia istantanea mentre il motore a combustione offre prestazioni sostenute.";
export const engineering_technical_spec = "Specifica Tecnica";
export const engineering_headline1 = "Progettato con";
export const engineering_headline2 = "tolleranze esatte.";
export const engineering_body = "Ogni numero qui sotto è misurato, non stimato. Il nostro processo è basato su metodologia di grado aerospaziale applicata alla costruzione automobilistica in carbonio.";
export const engineering_process_overview = "Panoramica del Processo";
export const engineering_docs_note = "Documentazione tecnica completa disponibile su richiesta di progetto";
export const engineering_request_docs = "Richiedi Documentazione";

export const atelier_title = "Atelier degli Interni";
export const atelier_subtitle = "Artigianato Su Misura";
export const atelier_desc = "Il nostro Atelier degli Interni trasforma gli abitacoli in santuari personalizzati. Ogni cucitura, ogni superficie, ogni dettaglio è adattato alla tua visione. Dalle pelli selezionate a mano alle trame di carbonio personalizzate, creiamo interni che riflettono la tua individualità.";
export const atelier_cta = "Progetta il Tuo Interno";
export const atelier_craftsmanship_label = "Artigianato";
export const atelier_headline = "INTERNO / ATELIER";
export const atelier_body = "Dove i materiali incontrano la maestria. Ogni cucitura, ogni superficie, progettata per la perfezione.";
export const atelier_material_label = "MATERIALE";
export const atelier_our_services = "I NOSTRI SERVIZI";
export const atelier_schedule = "PIANIFICA CONSULENZA";

export const performance_title = "Linea Performance";
export const performance_subtitle = "Potenza Senza Compromessi";
export const performance_spec_power = "Potenza Erogata";
export const performance_spec_torque = "Coppia Massima";
export const performance_spec_weight = "Peso a Vuoto";
export const performance_spec_acceleration = "0-100 km/h";
export const performance_spec_top_speed = "Velocità Massima";
export const performance_cta = "Visualizza Specifiche";
export const performance_label = "Performance";
export const performance_headline1 = "DINAMICA";
export const performance_headline2 = "PROGETTATA";

export const models_title = "Galleria Modelli";
export const models_subtitle = "Esplora la Nostra Collezione";
export const models_search_placeholder = "Cerca modelli...";
export const models_filter_all = "Tutti i Modelli";
export const models_filter_hypercar = "Hypercar";
export const models_filter_gt = "GT";
export const models_filter_roadster = "Roadster";
export const models_filter_limited = "Edizione Limitata";
export const models_view = "Visualizza Dettagli";
export const models_configure = "Configura";
export const models_config_label = "Configurazione · Modelli";
export const models_headline = "MODELLI / GALLERIA";
export const models_body = "Scegli il tuo veicolo base e configuralo secondo la tua visione. Ogni progetto viene eseguito individualmente.";
export const models_available = "modelli disponibili per la configurazione";
export const models_ask_another = "CHIEDI DI UN ALTRO MODELLO";
export const models_swipe = "SCORRI PER ESPLORARE";

export const process_title = "Processo di Build";
export const process_subtitle = "Dalla Visione alla Realtà";
export const process_step1_title = "Consulenza";
export const process_step1_desc = "Inizia il tuo viaggio con il nostro team di progettazione. Esploreremo la tua visione, preferenze e requisiti di prestazioni.";
export const process_step2_title = "Configurazione";
export const process_step2_desc = "Seleziona ogni dettaglio—dai motivi di tessitura del carbonio ai materiali degli interni. Visualizza il tuo build in tempo reale.";
export const process_step3_title = "Ingegneria";
export const process_step3_desc = "I nostri ingegneri ottimizzano ogni componente secondo le tue specifiche, garantendo prestazioni massime e affidabilità.";
export const process_step4_title = "Fabbricazione";
export const process_step4_desc = "Maestri artigiani danno vita alla tua visione, costruendo a mano ogni componente con precisione e cura.";
export const process_step5_title = "Consegna";
export const process_step5_desc = "Vivi il momento in cui il tuo capolavoro arriva. Consegna completa e supporto a vita inclusi.";
export const process_label = "Processo di Build";
export const process_headline1 = "Dal Carbonio Grezzo";
export const process_headline2 = "all'Arte Finita.";
export const process_body = "Ogni build ORVANTHE segue un meticoloso processo in sei fasi. Nessuna scorciatoia. Nessun outsourcing. Ogni veicolo è un'espressione singolare di precisione e artigianato.";
export const process_start_build = "Inizia il Tuo Build";
export const process_hours = "Ore per Build";
export const process_craftsmen = "Maestri Artigiani";
export const process_inspection = "Punti di Ispezione";
export const process_warranty = "Garanzia Strutturale";

export const contact_title = "Inizia il Tuo Build";
export const contact_subtitle = "Creiamo Qualcosa di Straordinario";
export const contact_form_name = "Nome Completo";
export const contact_form_email = "Indirizzo Email";
export const contact_form_phone = "Numero di Telefono";
export const contact_form_interest = "Sono Interessato A";
export const contact_form_interest_new = "Nuovo Build";
export const contact_form_interest_custom = "Progetto Personalizzato";
export const contact_form_interest_carbon = "Divisione Carbon";
export const contact_form_interest_atelier = "Atelier degli Interni";
export const contact_form_interest_inquiry = "Richiesta Generale";
export const contact_form_message = "Raccontaci la Tua Visione";
export const contact_form_submit = "Invia Richiesta";
export const contact_form_submitting = "Invio in Corso...";
export const contact_form_success = "Grazie! Ti contatteremo entro 24 ore.";
export const contact_form_error = "Qualcosa è andato storto. Riprova.";
export const contact_form_required = "Questo campo è obbligatorio";
export const contact_form_email_invalid = "Inserisci un indirizzo email valido";
export const contact_configure_label = "Configura";
export const contact_headline1 = "INIZIA IL TUO";
export const contact_headline2 = "BUILD";
export const contact_body = "Seleziona il tuo pacchetto, scegli il tuo veicolo, e creeremo qualcosa di irripetibile.";
export const contact_step_package = "Pacchetto";
export const contact_step_vehicle = "Veicolo";
export const contact_step_details = "Dettagli";
export const contact_continue = "Continua";
export const contact_back = "Indietro";
export const contact_edit = "Modifica";
export const contact_change = "Cambia";
export const contact_select_brand = "Seleziona Marca *";
export const contact_select_model = "Seleziona Modello *";
export const contact_enter_vehicle = "Inserisci il Tuo Veicolo *";
export const contact_timeline_label = "Tempistica Preferita";
export const contact_timeline_placeholder = "Seleziona tempistica";
export const contact_timeline_asap = "Il prima possibile";
export const contact_timeline_1_3 = "1–3 mesi";
export const contact_timeline_3_6 = "3–6 mesi";
export const contact_timeline_6_12 = "6–12 mesi";
export const contact_timeline_exploring = "Solo esplorando le opzioni";
export const contact_additional_details = "Dettagli Aggiuntivi";
export const contact_message_placeholder = "Raccontaci la tua visione — preferenze di colore, modifiche specifiche, ispirazione...";
export const contact_submit_inquiry = "Invia Richiesta";
export const contact_processing = "Elaborazione in Corso...";
export const contact_success = "Grazie! Ti contatteremo entro 24 ore per discutere del tuo build.";
export const contact_error = "Compila tutti i campi obbligatori e riprova.";
export const contact_location = "Varsavia, PL";

export const news_title = "Ultime Notizie";
export const news_subtitle = "Aggiornamenti da Veragua";
export const news_read_more = "Leggi di Più";

export const social_title = "Segui il Nostro Viaggio";
export const social_subtitle = "Dietro le Quinte";
export const social_view_post = "Visualizza Post";

export const footer_tagline = "Eccellenza Ingegneristica. Prestazioni Senza Compromessi.";
export const footer_company = "Azienda";
export const footer_company_about = "Chi Siamo";
export const footer_company_careers = "Carriere";
export const footer_company_press = "Stampa";
export const footer_company_contact = "Contatto";
export const footer_models = "Modelli";
export const footer_models_hypercar = "Serie Hypercar";
export const footer_models_gt = "Collezione GT";
export const footer_models_roadster = "Linea Roadster";
export const footer_models_limited = "Edizioni Limitate";
export const footer_services = "Servizi";
export const footer_services_carbon = "Divisione Carbon";
export const footer_services_atelier = "Atelier degli Interni";
export const footer_services_bespoke = "Progetti Su Misura";
export const footer_services_support = "Supporto Proprietari";
export const footer_legal = "Legale";
export const footer_legal_privacy = "Informativa sulla Privacy";
export const footer_legal_terms = "Termini di Servizio";
export const footer_legal_cookies = "Politica sui Cookie";
export const footer_copyright = "© 2024 Veragua. Tutti i diritti riservati.";
export const footer_powered = "Creatore di Siti Web";
export const footer_copyright_text = "© ORVANTHE 2025. TUTTI I DIRITTI RISERVATI.";
export const footer_tagline_short = "Realizzato in Carbonio. Costruito Senza Compromessi.";

export const about_hero_title = "Chi Siamo";
export const about_hero_subtitle = "Progettare il Futuro delle Prestazioni";
export const about_hero_subtitle_short = "Dove l'ingegneria di precisione incontra la visione artistica";
export const about_hero_scroll = "SCORRI";
export const about_story_title = "La Nostra Storia";
export const about_story_text = "Fondata sul principio che il compromesso non ha posto nell'eccellenza automobilistica, Veragua è emersa da una visione per ridefinire ciò che è possibile. Non costruiamo auto—progettiamo esperienze che trascendono i confini convenzionali.";
export const about_story_heading = "Gli Inizi";
export const about_story_p1 = "Fondata nel 2018, ORVANTHE è emersa da una visione singolare: trascendere i confini tra ingegneria automobilistica e belle arti. Quello che è iniziato come un progetto passione in un modesto laboratorio si è evoluto in un atelier di eccellenza automobilistica riconosciuto a livello mondiale.";
export const about_story_p2 = "Il nostro fondatore, spinto da un'ossessione per la perfezione e un profondo rispetto per il patrimonio automobilistico, ha riunito un team di maestri artigiani, ingegneri e designer che condividevano gli stessi standard intransigenti. Insieme, hanno inaugurato un nuovo approccio alla personalizzazione automobilistica.";
export const about_story_p3 = "Ogni creazione ORVANTHE nasce da centinaia di ore di pianificazione meticolosa, scansione 3D e finitura a mano. Non modifichiamo semplicemente i veicoli; li ricostruiamo a livello molecolare, reimmaginando ciò che è possibile quando l'arte incontra la precisione ingegneristica.";
export const about_story_est = "Fond. 2018";
export const about_story_since = "PRECISIONE DAL PRIMO GIORNO";
export const about_philosophy_title = "La Nostra Filosofia";
export const about_philosophy_text = "Ogni decisione, ogni componente, ogni dettaglio è guidato da un impegno incrollabile verso la perfezione. Crediamo nella purezza dello scopo, nell'eleganza dell'ingegneria e nella ricerca incessante delle prestazioni.";
export const about_craftsmanship_title = "Artigianato";
export const about_craftsmanship_text = "I nostri maestri artigiani combinano tecniche tradizionali con tecnologia all'avanguardia. Ogni veicolo è costruito a mano, garantendo che ogni superficie, ogni cucitura, ogni componente soddisfi i nostri standard rigorosi.";
export const about_vision_title = "La Nostra Visione";
export const about_vision_text = "Immaginiamo un futuro in cui prestazioni e sostenibilità coesistono, dove la tecnologia migliora l'esperienza di guida senza diminuirla, e dove ogni viaggio è un'espressione di arte automobilistica.";
export const about_craft_heading = "In Numeri";
export const about_craft_body = "Precisione, dedizione ed eccellenza misurate";
export const about_craft_quote = "Non costruiamo auto. Scolpiamo sogni di carbonio e acciaio, creando poesia ingegneristica che si muove a 320 km/h.";
export const about_craft_manifesto = "MANIFESTO ORVANTHE";
export const about_craft_stat1_label = "Ore per Build";
export const about_craft_stat1_desc = "Attenzione meticolosa ad ogni dettaglio";
export const about_craft_stat2_label = "Maestri Artigiani";
export const about_craft_stat2_desc = "Decenni di esperienza combinata";
export const about_craft_stat3_label = "Tolleranza di Precisione";
export const about_craft_stat3_desc = "Ingegneria a livello microscopico";
export const about_craft_stat4_label = "Rifinito a Mano";
export const about_craft_stat4_desc = "Nessuna scorciatoia, nessun compromesso";
export const about_phil_heading = "La Nostra Filosofia";
export const about_phil_body = "Quattro principi che guidano ogni decisione, ogni design, ogni dettaglio";
export const about_phil_p1_title = "Visione Senza Compromessi";
export const about_phil_p1_desc = "Rifiutiamo di accettare limitazioni. Ogni progetto inizia con una domanda: e se potessimo farlo meglio? Questa ricerca incessante della perfezione guida ogni decisione, ogni misurazione, ogni finitura.";
export const about_phil_p2_title = "Artigianato di Maestro";
export const about_phil_p2_desc = "In un'era di automazione, difendiamo il tocco umano. I nostri maestri artigiani trascorrono anni a perfezionare le loro abilità, garantendo che ogni superficie, ogni cucitura, ogni dettaglio rifletta i più alti standard di qualità.";
export const about_phil_p3_title = "Innovazione Senza Compromessi";
export const about_phil_p3_desc = "Abbracciamo la tecnologia all'avanguardia — scansione 3D, ingegneria in fibra di carbonio, aerodinamica avanzata — ma mai a scapito dell'anima. La tecnologia serve l'arte, non il contrario.";
export const about_phil_p4_title = "Partnership con il Cliente";
export const about_phil_p4_desc = "Ogni creazione ORVANTHE è una collaborazione. Ascoltiamo, consigliamo, raffiniamo. La tua visione diventa la nostra missione, e insieme creiamo qualcosa che trascende le aspettative.";
export const about_vision_heading = "Guardando al Futuro";
export const about_vision_p1 = "Il futuro di ORVANTHE non riguarda il volume — riguarda l'impatto. Non comprometteremo mai i nostri standard per scalare la produzione. Invece, investiamo in materiali di nuova generazione, aerodinamica avanzata e pratiche ingegneristiche sostenibili.";
export const about_vision_p2 = "La nostra visione si estende oltre i build individuali. Stiamo creando un'eredità di innovazione, formando la prossima generazione di maestri artigiani e spingendo i confini del possibile quando arte e ingegneria convergono.";
export const about_vision_p3 = "Ogni veicolo ORVANTHE è una dichiarazione: che l'eccellenza non può essere affrettata, che la bellezza richiede pazienza, e che il vero lusso si misura non nel prezzo, ma nella ricerca della perfezione.";
export const about_vision_sustain_title = "Innovazione Sostenibile";
export const about_vision_sustain_desc = "Produzione a impatto zero entro il 2026";
export const about_vision_academy_title = "Accademia degli Artigiani";
export const about_vision_academy_desc = "Formare la prossima generazione di artigiani";
export const about_vision_materials_title = "Materiali del Futuro";
export const about_vision_materials_desc = "Pionieri nei compositi di grado aerospaziale";
export const about_vision_statement = "Questo non è styling. Questa è ricostruzione.";

export const back_to_top = "Torna su";

export const common = {
  nav: {
    carbon: 'CARBON',
    builds: 'PROGETTI',
    atelier: 'ATELIER',
    performance: 'PERFORMANCE',
  },
  contact: {
    hero: {
      eyebrow: 'Mettiti in contatto',
      title: 'Contatto',
      subtitle: 'Contattaci per discutere la tua visione, programmare una visita allo studio o informarti sui nostri servizi.'
    },
    info: {
      title: 'Informazioni sullo Studio',
      address: {
        label: 'Indirizzo',
        value: 'Aleje Jerozolimskie 123',
        subvalue: '00-001 Varsavia, Polonia'
      },
      email: {
        label: 'Email',
      },
      phone: {
        label: 'Telefono',
      },
      hours: {
        label: 'Orari dello Studio',
        value: 'Lunedì – Venerdì: 9:00 – 18:00',
        subvalue: 'Sabato: Solo su appuntamento'
      },
      social: 'Seguici'
    },
    visit: {
      title: 'Programma una visita allo studio',
      description: 'Vivi ORVANTHE di persona. Visita le nostre strutture, incontra il nostro team ed esplora la nostra biblioteca di materiali e i progetti completati.',
      benefit1: 'Consulenza privata con il nostro team di design',
      benefit2: 'Selezione pratica di materiali e finiture',
      benefit3: 'Visualizza i progetti attuali in corso',
      cta: 'Prenota la tua visita',
      form: {
        title: 'Prenota la tua visita allo studio',
        subtitle: 'Seleziona la data e l\'ora preferite. Confermeremo la disponibilità entro 24 ore.',
        name: 'Nome completo',
        email: 'Indirizzo email',
        phone: 'Numero di telefono',
        date: 'Data preferita',
        time: 'Ora preferita',
        visitors: 'Numero di visitatori',
        selectTime: 'Seleziona l\'ora',
        notes: 'Note aggiuntive',
        notesPlaceholder: 'Interessi o domande specifiche?',
        submit: 'Conferma prenotazione',
        submitting: 'Invio in corso...',
        validation: 'Si prega di compilare tutti i campi obbligatori.',
        success: {
          title: 'Visita programmata',
          message: 'La tua visita allo studio è stata confermata. Ti invieremo un\'email di conferma a breve.'
        }
      }
    },
    form: {
      title: 'Inviaci un messaggio',
      subtitle: 'Rispondiamo tipicamente entro 24 ore.',
      name: 'Nome completo',
      namePlaceholder: 'Mario Rossi',
      email: 'Indirizzo email',
      emailPlaceholder: 'mario@esempio.it',
      phone: 'Numero di telefono',
      phonePlaceholder: '+39 123 456 789',
      subject: 'Oggetto',
      subjectPlaceholder: 'Seleziona un oggetto',
      subjects: {
        general: 'Richiesta generale',
        carbon: 'Divisione Carbon',
        atelier: 'Atelier Interni',
        performance: 'Linea Performance',
        build: 'Richiesta progetto personalizzato',
        partnership: 'Opportunità di partnership'
      },
      message: 'Messaggio',
      messagePlaceholder: 'Raccontaci del tuo progetto o richiesta...',
      characters: 'caratteri',
      submit: 'Invia messaggio',
      sending: 'Invio in corso...',
      validation: 'Si prega di compilare tutti i campi obbligatori.',
      maxLength: 'Il messaggio non può superare 500 caratteri.',
      success: {
        title: 'Messaggio inviato',
        message: 'Grazie per averci contattato. Abbiamo ricevuto il tuo messaggio.',
        response: 'Il nostro team risponderà entro 24 ore.'
      }
    },
    map: {
      title: 'Trova il nostro studio',
      subtitle: 'Situato nel cuore di Varsavia',
      location: 'Posizione dello studio'
    },
    faq: {
      title: 'Domande frequenti',
      subtitle: 'Risposte rapide alle domande comuni',
      q1: {
        question: 'Qual è il tempo tipico per un progetto personalizzato?',
        answer: 'La maggior parte dei progetti richiede 8-16 settimane dalla consulenza iniziale alla consegna, a seconda della complessità e della disponibilità dei materiali. Servizi express sono disponibili per pacchetti selezionati.'
      },
      q2: {
        question: 'Spedite internazionalmente?',
        answer: 'Sì, spediamo in tutto il mondo. Tutti i componenti in carbonio sono accuratamente imballati e assicurati. Il supporto per l\'installazione può essere organizzato tramite la nostra rete di partner.'
      },
      q3: {
        question: 'Posso visitare lo studio senza appuntamento?',
        answer: 'Consigliamo di programmare una visita in anticipo per garantire che il nostro team sia disponibile per fornirti un tour e una consulenza completi.'
      },
      q4: {
        question: 'Quali metodi di pagamento accettate?',
        answer: 'Accettiamo bonifici bancari, carte di credito e criptovalute. È richiesto un deposito del 50% per iniziare il lavoro, con il saldo dovuto al completamento.'
      },
      q5: {
        question: 'Offrite servizi di installazione?',
        answer: 'Sì, l\'installazione professionale è disponibile presso il nostro studio o tramite la nostra rete di partner certificati in Europa e oltre.'
      },
      q6: {
        question: 'Quale garanzia fornite?',
        answer: 'Tutti i prodotti ORVANTHE sono coperti da una garanzia di 2 anni contro i difetti di fabbricazione. I componenti in carbonio includono una garanzia strutturale a vita.'
      },
      more: 'Hai ancora domande?',
      email: 'Inviaci un\'email direttamente'
    }
  }
};
